import React from 'react';
import styles from './BundleSection.module.scss';
import { classNameGenerator, clsx } from '@/utils';
import { useAppSelector } from '@/hooks';
import { useRouter } from 'next/router';

const BundleSection = () => {
    const cls = classNameGenerator(styles)
    const { data } = useAppSelector((state) => state.healthProgramV1);
    const router = useRouter();

    if (!data?.bundles) {
        return <></>
    }

    const { bundles } = data || []

    return (
        <section className={cls("bundle-section")}>
            <div className={cls("section-header")}>
                <h2>Shop for Bundles</h2>
                <button onClick={() =>router.push("https://shop.betheshyft.com/collections/all")} className={clsx(cls("view-all-link"), cls("desktop-only"))}>View all &rarr;</button>
            </div>

            <div className={cls("bundle-scroll-container")}>
                {bundles.map((item, index) => (
                    <div onClick={() =>router.push(item?.link)} className={cls("bundle-card")} key={index}>
                        <div className={cls("image-box")}>
                            <img src={item.image} alt={item.title} />
                        </div>
                        <div className={cls("content-box")}>
                            <div className={cls("content-inner")}>
                                <h3>{item.title}</h3>
                                <p className={cls("description")}>{item.description}</p>
                            </div>
                            <p className={cls("price")}>₹ {item.price}</p>
                        </div>
                    </div>
                ))}
            </div>

            <button onClick={() =>router.push("https://shop.betheshyft.com/collections/all")} className={clsx(cls("view-all-btn"), cls("mobile-only"))}>View All</button>
        </section>
    );
};

export default BundleSection;